// src/router/usuariosAgentes.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['coordenador_operacional']

const agentesBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Agentes',
        to: 'UsuariosAgentes'
    }
]

export default [
    {
        path: '/usuarios/agentes/',
        name: 'UsuariosAgentes',
        component: () => import('@/views/Usuarios/Agentes/UsuarioAgenteListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Agentes',
            breadcrumb: agentesBreadCrumb
        },
    },
    {
        path: '/usuarios/agentes/novo',
        name: 'UsuarioAgenteNovo',
        component: () => import('@/views/Usuarios/Agentes/NovoUsuarioAgentePage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Agente',
            breadcrumb: [
                ...agentesBreadCrumb,
                {
                    label: 'Novo Agente',
                    to: 'UsuarioAgenteNovo'
                }
            ]
        }
    },
    {
        path: '/usuarios/agentes/:id/edit',
        name: 'UsuarioAgenteEdit',
        component: () => import('@/views/Usuarios/Agentes/NovoUsuarioAgentePage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Agente',
            breadcrumb: [
                ...agentesBreadCrumb,
                {
                    label: 'Novo Agente',
                    to: 'UsuarioAgenteEdit'
                }
            ]
        }
    }
];
